export { FormInputControls, FormInputNames, FormInputTypes } from './FormInput/constants';
export { FormSelectComponents } from './FormSelect/constants';

export const FormCssId = 'form-template';

export const FormThemes = Object.freeze({
  DEFAULT: '',
  DARK_BACKGROUND: 'dark',
});

export const FormItemTypes = Object.freeze({
  RADIO: 'radio',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
  INPUT: 'input',
  AUTOCOMPLETE: 'autocomplete',
});
